"use client";

import React from "react";
import Link from "next/link";
import { BlogPost } from "@/types/blog";
import SectionBadge from "../ui/section-badge";
import ContentCarousel from "../ui/content-carousel";
import BlogCard from "../ui/blog-card";

interface RelatedArticlesProps {
  posts: BlogPost[];
  currentSlug: string;
}

export default function RelatedArticles({
  posts,
  currentSlug,
}: RelatedArticlesProps) {
  // Filter out current article and limit to 6 related posts
  const relatedPosts = posts
    .filter((post) => post.slug !== currentSlug)
    .slice(0, 6);

  if (relatedPosts.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-background pt-14">
      <section className="mx-auto flex w-full max-w-container px-6">
        <div className="flex w-full flex-col gap-8">
          <div className="flex flex-col items-center gap-4">
            <SectionBadge>Blog</SectionBadge>
            <h2 className="text-center font-medium text-4xl text-foreground tracking-tight lg:text-5xl mt-4">
              Read more
            </h2>
            <p className="text-center text-lg text-muted-foreground">
                More articles about AI and productivity
            </p>
          </div>

          <ContentCarousel
            items={relatedPosts}
            renderItem={(post) => (
              <Link href={`/blog/${post.slug}`} className="block h-full">
                <BlogCard
                  title={post.title}
                  description={post.description ?? ""}
                  imageUrl={post.coverImage}
                  aspectRatio="video"
                  imageFit={post.coverImageFit}
                />
              </Link>
            )}
          />
        </div>
      </section>
    </div>
  );
}

